import { render, staticRenderFns } from "./QuestionCategories.vue?vue&type=template&id=fb67e262&scoped=true&"
import script from "./QuestionCategories.vue?vue&type=script&lang=js&"
export * from "./QuestionCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb67e262",
  null
  
)

export default component.exports